var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7277 17.3005L3.496 33.576C2.72018 32.8402 2.3009 31.8309 2.3009 30.7372V5.20985C2.3009 4.09546 2.74127 3.08592 3.53819 2.32928L19.7277 17.3005Z",
    fill: "#2299F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7573 17.9733C33.7573 19.4455 32.96 20.749 31.6387 21.4854L27.0259 24.0505L21.3005 18.7513L19.7278 17.3005L25.7882 11.2234L31.6387 14.4617C32.96 15.1982 33.7573 16.5016 33.7573 17.9733Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7277 17.3005L3.53821 2.32923C3.74781 2.11857 4.02069 1.9295 4.29329 1.76131C5.61426 0.962352 7.20817 0.940977 8.57104 1.69838L25.7882 11.2234L19.7277 17.3005Z",
    fill: "#5ACF5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0258 24.0506L8.57099 34.2489C7.92109 34.6276 7.18667 34.7955 6.47385 34.7955C5.71911 34.7955 4.96431 34.6063 4.29325 34.186C3.9992 34.0177 3.72667 33.8074 3.49597 33.576L19.7277 17.3004L21.3004 18.7513L27.0258 24.0506Z",
    fill: "#F84437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google-Play.95f8e8937a9f1fe95b9d48854d8c1d21.svg";
export { ForwardRef as ReactComponent };